export default function slugify(str) {
  return str
    .toLowerCase()
    .replace(/ä/g, "_")
    .replace(/ö/g, "_")
    .replace(/ü/g, "_")
    .replace(/ß/g, "_")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // remove diacritics
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}